import React, { useState } from 'react';
import { FiMail, FiChevronDown, FiClock, FiHelpCircle, FiMessageCircle } from 'react-icons/fi';
import { FaFacebook, FaInstagram } from 'react-icons/fa';

const FAQS = [
  {
    q: 'كيف أنشئ حسابًا في تطبيق خدمة؟',
    a: 'من شاشة التسجيل، اختر ما إذا كنت عميلاً أو مقدم خدمة، ثم أكمل بياناتك الأساسية. بعد التحقق من بريدك الإلكتروني يصبح حسابك جاهزًا للاستخدام مباشرة.'
  },
  {
    q: 'كيف تعمل المحفظة والمدفوعات؟',
    a: 'كل معاملة تمر عبر المحفظة الرقمية داخل التطبيق، وتُخصم عمولة خدمة نسبتها 10%. يمكنك متابعة رصيدك وسجل معاملاتك من صفحة المحفظة في أي وقت.'
  },
  {
    q: 'هل يمكنني إلغاء طلب بعد إرساله؟',
    a: 'نعم، طالما لم يبدأ مقدم الخدمة بالتنفيذ. إذا بدأ التنفيذ، يُحدَّد مبلغ الاسترداد بحسب نسبة العمل المُنجَز.'
  },
  {
    q: 'كيف أطلب سحب أرصدتي من المحفظة؟',
    a: 'من صفحة "المحفظة"، اختر "طلب سحب"، وأدخل المبلغ المطلوب. تخضع طلبات السحب للمراجعة وقد تستغرق التحويل بضعة أيام عمل.'
  },
  {
    q: 'ماذا أفعل إذا واجهت مشكلة مع مقدم خدمة؟',
    a: 'يمكنك التواصل مع فريق الدعم مباشرة عبر البريد الإلكتروني أدناه، مع وصف واضح للمشكلة، وسنعمل على حلها بأسرع وقت ممكن.'
  }
];

const ContactUsScreen = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const launchEmail = (email) => {
    window.open(`mailto:${email}?subject=استفسار من تطبيق خدمة`, '_blank');
  };

  const launchUrl = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div dir="rtl" className="min-h-screen bg-[#F6F6F4]" style={{ fontFamily: "'Tajawal', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@700;800&family=Tajawal:wght@400;500;700&display=swap');
        .font-display { font-family: 'Cairo', sans-serif; }
      `}</style>

      {/* Header */}
      <div className="bg-khidma-black text-white">
        <div className="max-w-5xl mx-auto px-4 md:px-8 py-10 md:py-14 text-center">
          <div className="inline-flex bg-white/10 rounded-full p-3.5 mb-4">
            <FiMessageCircle className="text-white text-2xl" />
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-extrabold mb-2">مركز المساعدة والتواصل</h1>
          <p className="text-white/70 max-w-lg mx-auto text-sm md:text-base leading-relaxed">
            نحن هنا لمساعدتك. تواصل معنا مباشرة أو تصفّح الأسئلة الشائعة أدناه قبل إرسال رسالتك.
          </p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-8 -mt-6 md:-mt-8 pb-12 md:pb-16">

        {/* Contact method cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
          <button
            onClick={() => launchEmail('khidma046@gmail.com')}
            className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-all duration-200 flex flex-col items-center text-center shadow-sm group"
          >
            <div className="bg-red-100 rounded-full p-4 mb-3 group-hover:scale-110 transition-transform">
              <FiMail className="text-red-600 text-2xl" />
            </div>
            <span className="font-display font-bold text-gray-900">البريد الإلكتروني</span>
            <span className="text-xs text-gray-500 mt-1">khidma046@gmail.com</span>
          </button>

          <button
            onClick={() => launchUrl('https://www.instagram.com/khidma.4u?igsh=bXQ3bXJ6dGk1ZjJn')}
            className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-all duration-200 flex flex-col items-center text-center shadow-sm group"
          >
            <div className="bg-purple-100 rounded-full p-4 mb-3 group-hover:scale-110 transition-transform">
              <FaInstagram className="text-purple-600 text-2xl" />
            </div>
            <span className="font-display font-bold text-gray-900">انستغرام</span>
            <span className="text-xs text-gray-500 mt-1">تابعنا لآخر التحديثات</span>
          </button>

          <button
            onClick={() => launchUrl('https://www.facebook.com/share/1Bk1HkZ33w/')}
            className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-all duration-200 flex flex-col items-center text-center shadow-sm group"
          >
            <div className="bg-blue-100 rounded-full p-4 mb-3 group-hover:scale-110 transition-transform">
              <FaFacebook className="text-blue-600 text-2xl" />
            </div>
            <span className="font-display font-bold text-gray-900">فيسبوك</span>
            <span className="text-xs text-gray-500 mt-1">صفحتنا الرسمية</span>
          </button>
        </div>

        {/* Response time */}
        <div className="bg-white border border-gray-200 rounded-2xl p-5 md:p-6 flex items-center gap-4 mb-10 shadow-sm">
          <div className="bg-amber-100 rounded-full p-3 shrink-0">
            <FiClock className="text-amber-600 text-xl" />
          </div>
          <div>
            <p className="font-display font-bold text-gray-900 text-sm md:text-base">نسعى للرد خلال 24 ساعة</p>
            <p className="text-xs md:text-sm text-gray-500 mt-0.5">
              راسلنا عبر البريد الإلكتروني مع وصف واضح لطلبك أو مشكلتك لتسريع الاستجابة.
            </p>
          </div>
        </div>

        {/* FAQ */}
        <div>
          <div className="flex items-center gap-2 mb-5">
            <FiHelpCircle className="text-khidma-black text-xl" />
            <h2 className="font-display text-xl md:text-2xl font-bold text-gray-900">الأسئلة الشائعة</h2>
          </div>

          <div className="bg-white border border-gray-200 rounded-2xl divide-y divide-gray-100 shadow-sm overflow-hidden">
            {FAQS.map((faq, i) => (
              <div key={i}>
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between text-right px-5 py-4 hover:bg-gray-50 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
                >
                  <span className="font-medium text-gray-900 text-sm md:text-base">{faq.q}</span>
                  <FiChevronDown
                    className={`text-gray-400 shrink-0 transition-transform duration-200 ${openFaq === i ? 'rotate-180' : ''}`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-200 ease-in-out ${
                    openFaq === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-4 text-sm text-gray-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Terms footer link */}
        <div className="mt-10 bg-khidma-black text-white rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <h3 className="font-display text-lg font-bold mb-1">تريد حذف حسابك؟</h3>
            <p className="text-white/70 text-sm">يمكنك طلب حذف حسابك وبياناتك في أي وقت.</p>
          </div>
          <a
            href="/delete-account"
            className="shrink-0 bg-white text-khidma-black rounded-lg px-5 py-2.5 text-sm font-bold hover:bg-gray-100 transition-colors"
          >
            حذف الحساب
          </a>
        </div>

        <div className="mt-4 bg-white border border-gray-200 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 shadow-sm">
          <div>
            <h3 className="font-display text-lg font-bold mb-1 text-gray-900">تريد معرفة قواعد الاستخدام؟</h3>
            <p className="text-gray-500 text-sm">اطّلع على الشروط والأحكام قبل إرسال أي طلب.</p>
          </div>
          <a
            href="/rules-and-terms"
            className="shrink-0 bg-khidma-black text-white rounded-lg px-5 py-2.5 text-sm font-bold hover:bg-gray-800 transition-colors"
          >
            القواعد والشروط
          </a>
        </div>

        <div className="mt-4 bg-white border border-gray-200 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 shadow-sm">
          <div>
            <h3 className="font-display text-lg font-bold mb-1 text-gray-900">سياسة الخصوصية وحماية البيانات</h3>
            <p className="text-gray-500 text-sm">تعرف على حقوقك وكيفية التعامل مع بياناتك وفق متطلبات Google Play.</p>
          </div>
          <a
            href="/privacy-policy"
            className="shrink-0 bg-emerald-600 text-white rounded-lg px-5 py-2.5 text-sm font-bold hover:bg-emerald-700 transition-colors"
          >
            سياسة الخصوصية
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactUsScreen;